import { chatbotActionButton } from '../../components/action-buttons/action-buttons.consts';
import { ButtonColor } from '../../components/action-buttons/action-buttons.types';
import {
  ActionTooltip,
  PortfolioActionButton,
  PortfolioActionName,
  VisibilityRule,
} from './portfolio.types';

export const portfolioActionButtons: PortfolioActionButton[] = [
  {
    color: ButtonColor.Dark,
    icon: 'edit',
    name: PortfolioActionName.BULK_EDIT,
    tooltipKey: ActionTooltip.BULK_EDIT,
    visibilityRule: VisibilityRule.BULK_EDIT,
  },
  {
    color: ButtonColor.Blue,
    icon: 'upload',
    name: PortfolioActionName.UPLOAD,
    tooltipKey: ActionTooltip.UPLOAD,
    visibilityRule: VisibilityRule.UPLOAD,
  },
  {
    color: ButtonColor.Red,
    icon: 'add',
    name: PortfolioActionName.ADD,
    tooltipKey: ActionTooltip.ADD,
    visibilityRule: VisibilityRule.CREATE,
  },
  chatbotActionButton(PortfolioActionName.CHATBOT),
];

/** User-settings key the portfolio column arrangement is stored under. */
export const PORTFOLIO_COLUMN_LIST = 'column_list-portfolio';

/** Form key naming the fields this plant allows on the portfolio grid. */
export const PORTFOLIO_FIELDS_KEY = 'PORTFOLIO_MODULE_FORMKEY';

/** Namespace the portfolio column captions are translated from, by field name. */
export const PORTFOLIO_COLUMN_LABEL_PREFIX = 'defaultFields.portfolio-module.';

/** Kept so a second click reuses the dialog rather than opening another. */
export const PORTFOLIO_COLUMNS_DIALOG_ID = 'portfolio-select-columns-dialog';

export const PORTFOLIO_TEST_IDS = { columnSelect: 'portfolio-column-select' } as const;
